export interface ISiteSettings {
  id?: number;
  settingKey?: string | null;
  settingValue?: string | null;
}

export const defaultValue: Readonly<ISiteSettings> = {};
